import { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

/** Brand online / offline colors. */
export const ONLINE = '#08ecb8';
export const OFFLINE = '#ec0864';
export const ONLINE_TEXT = '#067a5f';
export const OFFLINE_TEXT = '#b0064a';

export type StatusSize = 'small' | 'medium';

export interface StatusPalette {
  bg: string;
  fg: string;
  dot: string;
  ring: string;
}

/**
 * Soft tint fills + text / dot colors (light / dark).
 */
export function getStatusPalette(status: boolean, mode: Theme['palette']['mode']): StatusPalette {
  const isDark = mode === 'dark';

  if (status) {
    return {
      bg: isDark ? alpha(ONLINE, 0.18) : '#d4faf0',
      fg: isDark ? ONLINE : ONLINE_TEXT,
      dot: ONLINE,
      ring: isDark ? alpha(ONLINE, 0.35) : '#a8f5e4',
    };
  }

  return {
    bg: isDark ? alpha(OFFLINE, 0.18) : '#fce4ee',
    fg: isDark ? '#ff6b9d' : OFFLINE_TEXT,
    dot: OFFLINE,
    ring: isDark ? alpha(OFFLINE, 0.35) : '#f5b8d0',
  };
}

/** Dot diameter and halo ring width matching StatusBadge sizes. */
export function getStatusDotMetrics(size: StatusSize) {
  if (size === 'medium') {
    return { dot: 8, ring: 3 };
  }
  return { dot: 7, ring: 3 };
}
